import getCookie from "./helpers/getCookie";
import setCookie from "./helpers/setCookie";

export default async function iziAddToCart(id) {
  if (typeof id === "undefined" || id === null) {
    return;
  }

  const iziButton = document.querySelector(
    `inpost-izi-button[data-currency-processed="1"]`,
  );
  if (iziButton) {
    // Remove the flag and return early - skip adding to cart
    iziButton.removeAttribute("data-currency-processed");
    return IPPWidgetOptions.basketBindingApiKey;
  }

  let data = new FormData();
  const form = window.document.querySelector("form.cart");

  if (form) {
    let submitter = form.querySelector("button[type=submit]");
    data = new FormData(form, submitter);
  } else {
    let variationInput = window.document.querySelector("input.variation_id");
    if (variationInput) {
      data.append("variation_id", variationInput.value);
      const variationsElement = document.querySelector(".variations");
      if (!variationsElement) return;
      const variationInputs = variationsElement.querySelectorAll("select");
      if (!variationInputs) return;
      variationInputs.forEach((element) =>
        data.append(element.name, element.value),
      );
    }
  }
  data.append("action", "add_to_cart");

  if (id !== undefined) {
    data.append("product_id", id);
  }

  let basketBindingApiKey = getCookie("basket_binding_api_key");
  if (basketBindingApiKey) {
    data.append("basket_binding_api_key", basketBindingApiKey);
  }

  const dummyContainer = document.createElement("div");
  dummyContainer.id = "izi-temp-container";
  dummyContainer.style.display = "none";
  document.body.appendChild(dummyContainer);

  const addToCartBtn = document.createElement("a");
  addToCartBtn.classList.add("ajax_add_to_cart", "add_to_cart_button");
  addToCartBtn.dataset.productId = id;
  addToCartBtn.href = "?add-to-cart=" + id;
  dummyContainer.appendChild(addToCartBtn);

  const addedBtn = document.createElement("span");
  addedBtn.classList.add("added_to_cart");
  dummyContainer.appendChild(addedBtn);

  try {
    const response = await fetch(InpostIziJavsscriptWoocommerce.ajaxurl, {
      method: "POST",
      body: data,
    });

    if (response.status >= 500) {
      throw new Error("Server error 500");
    }

    try {
      const responseData = await response.json();
      if (responseData.basket_binding_api_key) {
        IPPWidgetOptions.basketBindingApiKey = responseData.basket_binding_api_key;
        setCookie('basket_binding_api_key', responseData.basket_binding_api_key, 3600 * 24);
      }
    } catch (jsonError) {
      console.warn('[InPostPay] Failed to parse add_to_cart response JSON:', jsonError);
    }

    const originalAlert = window.alert;
    window.alert = function (message) {
      if (typeof message === "undefined" || message === "undefined") {
        console.warn(
          "[InPostPay] Zablokowano alert(undefined) z pluginu zewnętrznego",
        );
        return;
      }
      originalAlert.call(window, message);
    };

    jQuery(document.body).trigger("added_to_cart", [// poprawka IP-164
      response.fragments,
      response.cart_hash,
      jQuery(addToCartBtn)
    ]);

    setTimeout(() => {
      window.alert = originalAlert;
    }, 100);

    console.warn("[InPostPay] Trigger added_to_cart");
    if (typeof wc_add_to_cart_params !== "undefined") {
      jQuery.ajax({
        url: wc_add_to_cart_params.wc_ajax_url
          .toString()
          .replace("%%endpoint%%", "get_refreshed_fragments"),
        type: "POST",
        success: function (response) {
          if (response && response.fragments) {
            jQuery.each(response.fragments, function (key, value) {
              if (jQuery(key).length > 0) {
                try {
                  jQuery(key).html(jQuery(value).html());
                } catch (err) {
                  console.error("[InPostPay] Błąd przy podmianie fragmentu:", {
                    key,
                    valueSnippet: value?.toString()?.substring(0, 500),
                    error: err,
                    stack: err.stack,
                  });
                }
              } else {
                console.warn(
                  "[InPostPay] Nie znaleziono elementu do podmiany:",
                  key,
                );
              }
            });

            if (typeof wc_cart_fragments_params !== "undefined") {
              sessionStorage.setItem(
                wc_cart_fragments_params.fragment_name,
                JSON.stringify(response.fragments),
              );
              sessionStorage.setItem("wc_cart_hash", response.cart_hash);
            }

            jQuery(document.body).trigger("wc_fragments_refreshed");
            jQuery(document.body).trigger("added_to_cart", [
              null,
              null,
              jQuery(addToCartBtn),
            ]);

            setTimeout(() => {
              if (document.getElementById("izi-temp-container")) {
                document.getElementById("izi-temp-container").remove();
              }
            }, 100);
          }
        },
        error: function (xhr, status, error) {
          console.error("[FRAGMENTS-ERROR]", status, error, xhr.responseText);

          if (document.getElementById("izi-temp-container")) {
            document.getElementById("izi-temp-container").remove();
          }
        },
      });
    } else {
      jQuery(document.body).trigger("added_to_cart", [
        null,
        null,
        jQuery(addToCartBtn),
      ]);

      setTimeout(() => {
        if (document.getElementById("izi-temp-container")) {
          document.getElementById("izi-temp-container").remove();
        }
      }, 100);
    }
  } catch (e) {
    console.error("[InPostPay] Błąd przy ładowaniu koszyka:", e, e.stack);

    if (document.getElementById("izi-temp-container")) {
      document.getElementById("izi-temp-container").remove();
    }
  }

  return IPPWidgetOptions.basketBindingApiKey;
}
